import Content from "./content";
import { _ } from "~/i18n";
import { icon, node, stripHtmlElements } from "~/util/dom";
import { firmStats } from "~/util/review";
import DOMPurify from "dompurify";

interface IServiceItemData {
	id: number;
	active: boolean;
	categoryId: number;
	text: string;
	title: string;
	urlDetail: string;
}

interface IServiceItem {
	elm: HTMLDivElement;
	// TODO: tohle by melo mit typ podle toho, jak to vypada v datech detailu, ale to jeste neni otypovane a jen tak nebude, tak je to tady
	data: IServiceItemData;
	logged: boolean;
}

/**
 * @class Nabídky, akce, události firem
 */
export default class Services extends Content {
	_items: Array<IServiceItem>;

	_observer: IntersectionObserver;

	constructor(data: any, options: any) {
		super(data, options);

		this._build2();
	}

	_build2() {
		this._items = [];
		this._dom.container.classList.add("content-services");
		if (!this._data || !this._data.result || !this._data.result.length) {
			return;
		}

		this._dom.container.appendChild(node("h3", { innerHTML: _("detail.content.services.title", DOMPurify.sanitize(this._options.title)) }));

		Mapy.getComponent("logger").log("view", {
			number: this._data.result?.length || 0,
			origin: "firmy-vizitky-akce",
		});

		if ("IntersectionObserver" in window) {
			this._observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const index = this._items.findIndex(item => item.elm.contains(entry.target as Node));

						if (index > -1 && !this._items[index].logged) {
							firmStats("firmy-sluzba-doruceni", {
								id: this._options.id,
								stats: this._options.stats,
								inactive: this._options.inactive,
							}, {
								placeId: 1,
								typeId: 7,
								marketOfferId: this._items[index].data.id,
								marketOfferOrder: index + 1,
							});

							this._items[index].logged = true;
						}
					}
				});
			});
		}

		for (let index = 0; index < Math.min(this._data.result.length, 3); index++) {
			if (this._data.result[index].active) {
				const elm = this._buildItem(this._data.result[index]);

				this._items.push({
					elm,
					data: this._data.result[index],
					logged: false,
				});

				if ("IntersectionObserver" in window) {
					this._observer.observe(elm);
				// po dohode se Sarlotou, kdo neumi observer, dostane analytiku doruceni hned
				} else {
					firmStats("firmy-sluzba-doruceni", {
						id: this._options.id,
						stats: this._options.stats,
						inactive: this._options.inactive,
					}, {
						placeId: 1,
						typeId: 7,
						marketOfferId: this._data.result[index].id,
						marketOfferOrder: index + 1,
					});
				}
			}
		}

		this._dom.container.addEventListener("click", this);
	}

	destroy() {
		super.destroy();

		if ("IntersectionObserver" in window) {
			this._observer?.disconnect();
			this._observer = undefined;
		}
	}

	handleEvent(event: MouseEvent) {
		const index = this._items.findIndex(item => item.elm.contains(event.target as Node));

		if (index > -1) {
			firmStats("firmy-sluzba-akce", {
				id: this._options.id,
				stats: this._options.stats,
				inactive: this._options.inactive,
			}, {
				placeId: 1,
				typeId: 7,
				marketOfferId: this._items[index].data.id,
				marketOfferOrder: index + 1,
			});
		}
	}

	_buildItem(data: IServiceItemData) {
		const div = node("div", { className: "item" });
		const link = data.urlDetail ? `<a href="${data.urlDetail}" rel="noopener" target="_blank" data-log-ignore="1">%s</a>` : "%s";
		const content = node("div", { className: "text" });
		const parts: Array<string> = [];

		// ikona
		div.appendChild(icon("offer"));

		parts.push(`<h4>${link.replace("%s", data.title)}</h4>`);

		if (data.text) {
			// ocistime text o HTML a nove radky
			parts.push(`<p>${link.replace("%s", stripHtmlElements(data.text))}</p>`);
		}

		content.innerHTML = DOMPurify.sanitize(parts.join(""));
		div.appendChild(content);

		this._dom.container.appendChild(div);

		return div;
	}
}
